import { Injectable } from '@angular/core';
import {  Response, Headers, ResponseContentType, RequestMethod } from '@angular/http';
import "rxjs/add/operator/map"
  
 import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { Client } from '../entity/exhibitor';
 
@Injectable()
export class ReportingService {
  private baseUrlReporting: string = environment.restApi+'reporting';
  constructor( private httpClient:HttpClient ) {

}

  printNotification(client:Client): any {
      //console.log("printNotificationPdf"+client.raisonSocial);
      
    return this.httpClient.get(this.baseUrlReporting + '/printNotificationPdf/'+   client.idClient, { responseType: "blob"})  ;
  }
  
  
  private getHeaders1() {
    const headers = new Headers();
    headers.append('Accept', 'application/pdf');
    headers.append('Content-Type', 'application/pdf');
    return headers;
  }
}

 
 

 